import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Jarvis from './pages/Jarvis';
import Home from './pages/Home';
import Player from './pages/Player';
import Punishments from './pages/Punishments';
import Navbar from './components/Navbar';
import RedirectComponent from './components/RedirectComponent';
import NetherGamesBanner from './components/NetherGamesBanner';
import NotFound from './pages/404';
import Test from './pages/PlayerTest';
import Footer from './components/Footer';
import History from './pages/History';
import Ng from './pages/Ng';

function App() {
  return (
    <Router>
      <div className="App drawer drawer-mobile" style={{ overflowX: 'hidden' }}>
        <div className="drawer-content">

          <Navbar />
          <NetherGamesBanner />
          {/* FIX: className typo (was classMame) */}
          <main className="bg-gradient-to-b from-slate-900 to-black">
            <Routes>
              <Route path="/" element={<Home />} />

              {/* Redirects */}
              <Route path="/support" element={<RedirectComponent to="https://support.notreal003.org" />} />
              <Route path="/report" element={<RedirectComponent to="https://request.notreal003.org/report" />} />
              <Route path="/apply" element={<RedirectComponent to="https://request.notreal003.org/support" />} />
              <Route path="/guild" element={<RedirectComponent to="https://request.notreal003.org/apply" />} />
              <Route path="/discord" element={<RedirectComponent to="https://discord.gg/WmzBjsxYWB" />} />
              <Route path="/d" element={<RedirectComponent to="https://discord.gg/WmzBjsxYWB" />} />
              <Route path="/status" element={<RedirectComponent to="https://status.notreal003.org" />} />
              <Route path="/status" element={<RedirectComponent to="https://status.notreal003.org" />} />
              <Route path="/terms" element={<RedirectComponent to="https://support.notreal003.org/terms" />} />
              <Route path="/privacy" element={<RedirectComponent to="https://support.notreal003.prg/privacy" />} />
              <Route path="/request" element={<RedirectComponent to="https://request.notreal003.org" />} />
              <Route path="/requests" element={<RedirectComponent to="https://request.notreal003.org" />} />
              <Route path="/bot" element={<RedirectComponent to="https://discord.com/oauth2/authorize?client_id=1154035556993470565&permissions=1135782425656385&integration_type=0&scope=applications.commands+bot" />} />
              <Route path="/yt" element={<RedirectComponent to="https://youtube.com/@notnt77?si=VYMvcWcwVCnpeZGL" />} />
              <Route path="/youtube" element={<RedirectComponent to="https://youtube.com/@notnt77?si=VYMvcWcwVCnpeZGL" />} />
              <Route path="/x" element={<RedirectComponent to="https://x.com/NotNT77" />} />
              <Route path="/twitter" element={<RedirectComponent to="https://x.com/NotNT77" />} />
              <Route path="/github" element={<RedirectComponent to="https://github.com/NotReal003" />} />
              <Route path="/invite" element={<RedirectComponent to="https://discord.com/oauth2/authorize?client_id=1154035556993470565&permissions=1128085444754161&integration_type=0&scope=bot" />} />
              <Route path="/creators" element={<RedirectComponent to="https://support.notreal003.org/creator-code" />} />

              {/* Pages */}
              <Route path="/punishments/:player" element={<Punishments />} />
              <Route path="/test" element={<Test />} />
              <Route path="/jarvis" element={<Jarvis />} />
              <Route path="/player" element={<Player />} />
              <Route path="/players" element={<Player />} />
              <Route path="/players/:player" element={<Player />} />
              <Route path="/p" element={<Player />} />
              <Route path="/p/:player" element={<Player />} />
              <Route path="/History" element={<History />} />
              <Route path="/ng/guest-book" element={<Ng />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
